// PacienteHeaderDesktop — header full-width para el shell paciente en
// viewport desktop (lg:). Fetch interno del nombre del paciente vía
// useProfilePaciente + cálculo de fecha. Cero props al caller.
//
// Usado por ProgresoPaciente, HistorialSesiones, PerfilPaciente en el
// bloque de desktop paciente end-to-end. HomePaciente mantiene su
// header desktop inline (que ya tiene el nombre desde props del wrapper
// con datos del hero) — no lo cambiamos para no meter un fetch
// duplicado y flash de skeleton en el home.
//
// Idéntico patrón visual al KineHeader (bg-card + border-b + padding
// px-8 py-3) y al header desktop inline de HomePaciente.

import { useProfilePaciente } from "@/lib/supabase/queries/useProfilePaciente";
import { RoleToggle } from "@/app/components/RoleToggle";
import { DarkModeToggle } from "@/app/components/DarkModeToggle";
import logoGonixLight from "@/assets/logo-gonix-light.png";
import logoGonixDark from "@/assets/logo-gonix-dark.png";

export function PacienteHeaderDesktop() {
  const { data } = useProfilePaciente();
  const nombre = data?.paciente.nombre ?? "";
  const primerNombre = nombre.split(" ")[0] || "";

  const hoy = new Date().toLocaleDateString("es-AR", {
    weekday: "long",
    day: "numeric",
    month: "short",
  });

  return (
    <header className="hidden lg:flex items-center justify-between px-8 py-3 border-b border-border bg-card">
      <div className="flex items-center gap-3 min-w-0">
        <img
          src={logoGonixLight}
          alt="Gonix"
          className="block dark:hidden h-10 w-auto object-contain shrink-0"
        />
        <img
          src={logoGonixDark}
          alt="Gonix"
          className="hidden dark:block h-10 w-auto object-contain shrink-0"
        />
        <div className="min-w-0">
          <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">
            {hoy}
          </p>
          <h1 className="text-xl font-bold text-primary mt-0.5 truncate">
            {primerNombre ? `Hola, ${primerNombre} 👋` : "Gonix"}
          </h1>
        </div>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <RoleToggle />
        <DarkModeToggle />
        <button
          className="h-10 w-10 rounded-full bg-primary/10 text-primary font-bold text-sm flex items-center justify-center shrink-0 overflow-hidden"
          aria-label="Avatar del paciente"
        >
          {primerNombre[0] ?? "P"}
        </button>
      </div>
    </header>
  );
}
